/*!
 * DHL User Interface Library - https://docs.uilibrary.dhl
 *   9fbef606107a605d69c0edbcd8029e5d
 */
const DHL_CARD_TAG = {
    DIV: "div",
    LI: "li",
};
var DhlCardSizes;
(function (DhlCardSizes) {
    DhlCardSizes["SM"] = "sm";
    DhlCardSizes["MD"] = "md";
})(DhlCardSizes || (DhlCardSizes = {}));
const DHL_CARD = {
    TAG: DHL_CARD_TAG,
};

export { DhlCardSizes as D, DHL_CARD as a };

//# sourceMappingURL=constants-bf7d537d.js.map